// components/ScrollManager.js
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const ScrollManager = () => {
  const location = useLocation();

  useEffect(() => {
    // Only run if we are not on the homepage
    if (location.pathname !== '/') {
      const enforceScrollY = () => {
        if (window.scrollY <= 0) {
          window.scrollTo(0, 1); // force scrollY to 1
        }
      };

      // Initial scroll to 1
      enforceScrollY();

      // Use scroll listener to force scrollY > 0
      window.addEventListener('scroll', enforceScrollY, { passive: true });

      return () => {
        window.removeEventListener('scroll', enforceScrollY);
      };
    }
  }, [location]);

  return null;
};

export default ScrollManager;
